"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const OauthBase_1 = __importDefault(require("./OauthBase"));
class Oauth extends OauthBase_1.default {
}
module.exports = Oauth;
